import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookmarkModeEnum } from 'src/modules/shared/constants';

interface Scroll {
  shouldScroll: boolean;
  blockId: string;
}

export interface BookmarkSlice {
  bookmarkMode: BookmarkModeEnum;
  currentBookmarkId: string;
  scroll?: Scroll;
}

const initialState: BookmarkSlice = {
  bookmarkMode: BookmarkModeEnum.DISABLED,
  currentBookmarkId: '',
};

const bookmarkSlice = createSlice({
  name: 'bookmark',
  initialState,
  reducers: {
    setBookmarkMode: (state, action: PayloadAction<BookmarkModeEnum>) => {
      return { ...state, bookmarkMode: action.payload };
    },
    setCurrentBookmarkBlockId: (state, action: PayloadAction<string>) => {
      return { ...state, currentBookmarkId: action.payload };
    },
    setScroll: (state, action: PayloadAction<Scroll>) => {
      return { ...state, scroll: action.payload };
    },
    resetScroll: (state) => {
      return { ...state, scroll: undefined };
    },
    resetBookmark: () => initialState,
  },
});

export const { setBookmarkMode, setCurrentBookmarkBlockId, resetBookmark, setScroll, resetScroll } =
  bookmarkSlice.actions;

export const { reducer: bookmarkReducer } = bookmarkSlice;
